export function Header() {
  return (
    <header className={"p-4 bg-white"}>
      <img className={"h-10"} src={"/logo-purple.png"} alt={"JustMeet"} />
    </header>
  );
}
